import Vue from 'vue'
import {adminRoles, UserRoleEnum} from '@/enums/userRolesEnum'
import { HTTP } from '@/utils/httpCommonUtil'
import VueSimpleSpinner from 'vue-simple-spinner'
import { BallPulseLoader } from 'vue-loaders';
import { globalObject } from '@/utils/proxyDataUtil'

import FacilityControl from '@/componentsReusable/FacilityControl.vue'
import StateControl from '@/componentsReusable/StateControl.vue'
import CustomDropdownControl from '@/componentsReusable/CustomDropdownControl.vue'
import ButtomToggleControl from '@/componentsReusable/ButtonToggleControl.vue'
import flatPickr from 'vue-flatpickr-component';
import { ViewStateType } from '@/enums/ViewStateType';

export default Vue.extend({
  name: 'FacilitiesAdvancedSearch',
  data () {
    return {
      UserRoleEnum: UserRoleEnum,
      isAuthorized: false,
      processing: false,
      loadingSearchResults: false,

      searchCountResults: 0,
      allowForceResultsMaximum: 500,
      allowForceResults: false,
      searchResults: [],

      searchParametersCardExpanded: true,
      pullingReportData: false,

      advancedSearchFilters: {
        statusFilters: {
          filters: [],
          isAnd: false
        },
        ownerFilters: {
          filters: [],
          isAnd: false
        },
        specialtyFilters: {
          filters: [],
          isAnd: false
        },
        stateAddressFilters: {
          filters: [],
          isAnd: false
        },
        boardCertified: {
          isRequired: -1
        },
        certificationFilters: {
          filters: [],
          isAnd: false
        },
        providerTypeFilters: {
          filters: [],
          isAnd: false
        },
      },

    }
  },
  components: {
    VueSimpleSpinner,
    BallPulseLoader,
    FacilityControl,
    StateControl,
    CustomDropdownControl,
    flatPickr,
    ButtomToggleControl
  },
  beforeMount: function () {
    this.isAuthorized = this.$store.getters['user/hasRole'](adminRoles);
  },
  mounted: function () {
    if (this.$store.state.viewState[ViewStateType.FACILITY_SEARCH_ADVANCED]){
      this.advancedSearchFilters = this.$store.state.viewState[ViewStateType.FACILITY_SEARCH_ADVANCED]
      this.searchFacilities();
    }
  },
  filters: {
    nickname (nickName: string ) {
      if (nickName && nickName.length) {
        return '(' + nickName + ')';
      }
      return '';
    },
    address2 (address2: string ) {
      if (address2 && address2.length) {
        return ', ' + address2;
      }
      return '';
    },
    paysMileage (paysMileage: boolean ) {
      return paysMileage ? 'Yes' : 'No';
    },
    fee (fee: any ) {
      if (fee) {
        return ' $' + fee;
      }
      return '$0';
    },
    phoneNumber (phoneNumber: string) {
      let formattedPhoneNumber = phoneNumber;
      if (phoneNumber && phoneNumber.length) {
        let phoneNumberArray = phoneNumber.match(/(\d)?(\d\d\d)?(\d\d\d)(\d\d\d\d)$/);
        if (!phoneNumberArray) { return formattedPhoneNumber; }
        formattedPhoneNumber = phoneNumberArray.length ? '' : formattedPhoneNumber;
        for (let i = 1; i < phoneNumberArray.length; i++) {
          if (phoneNumberArray[i]) {
            formattedPhoneNumber += phoneNumberArray[i] + '.';
          }
        }
        formattedPhoneNumber = formattedPhoneNumber.slice(0,formattedPhoneNumber.length - 1);
      } else {
        formattedPhoneNumber = 'NA';
      }
      return formattedPhoneNumber;
    },
    state (state: any) {
      return state.stateFull + ", " + state.stateAbbrev;
    },   
    stateWithComma (state: any) {
      return state ? ", " + state : '';
    }
  },
  methods: {
    addFilter (filterList: any[], filter: any) {
      if(!filterList.some( ( (filterInstance: any) => filterInstance.id === filter.id ) ) ) {
        filterList.push(filter);
      }
    },
    removeFilter(filtersList: any[], filterId: Number) {
      for (let i=0; i<filtersList.length; i++) {
        if (filtersList[i].id === filterId) {
          filtersList.splice(i,1);
        }
      }
    },
    filterConjunctionUpdate (filterConjunctionBool: any, conjunctionBoo: boolean) {
      filterConjunctionBool = conjunctionBoo;
    },  
    
    clearAll () { 
      this.advancedSearchFilters.statusFilters.filters = [];
      this.advancedSearchFilters.statusFilters.isAnd = false;
      this.advancedSearchFilters.ownerFilters.filters = [];
      this.advancedSearchFilters.ownerFilters.isAnd = false;
      this.advancedSearchFilters.specialtyFilters.filters = [];
      this.advancedSearchFilters.specialtyFilters.isAnd = false;
      this.advancedSearchFilters.stateAddressFilters.filters = [];
      this.advancedSearchFilters.stateAddressFilters.isAnd = false;
      this.advancedSearchFilters.boardCertified.isRequired = -1;
      this.advancedSearchFilters.certificationFilters.filters = [];
      this.advancedSearchFilters.certificationFilters.isAnd = false;
      this.advancedSearchFilters.providerTypeFilters.filters = [];
      this.advancedSearchFilters.providerTypeFilters.isAnd = false;
      
      this.$store.dispatch('viewState/updateViewState', {name: ViewStateType.FACILITY_SEARCH_ADVANCED, value: null});
    },

    searchFacilities (force: boolean = false) {
      let self = this;
      let forceResults = force;
      if (this.processing) { return; }
      this.processing = true;
      self.loadingSearchResults = true;
      self.$store.dispatch('viewState/updateViewState', {name: ViewStateType.FACILITY_SEARCH_ADVANCED, value: JSON.parse(JSON.stringify(this.advancedSearchFilters))});
      HTTP.post('/api/facilities/advanced-search?forceResults=' + forceResults, { advancedSearchFilters: this.advancedSearchFilters} )
      .then(function (response) {
        self.processing = false;
        // If the response is a count, display the count message
        // If the response is a list, display the list

        // If the search results results are empty, display the count
        // If the count is greater than 0 display the count at the option to force retriving the results
        //  as long as the results are less than allowForceResultsMaximum

        let queryCountResults = response.data.data.count;
        
        self.searchCountResults = queryCountResults;
        self.searchResults = response.data.data.results;
        self.allowForceResults = queryCountResults < self.allowForceResultsMaximum;

        self.loadingSearchResults = false;
      })
      .catch(function () {
        self.loadingSearchResults = false;

        self.processing = false;
        // if there was an error, "notify" the error
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error Getting Results',
          text: 'Something went wrong getting search results!',
        });  
      })
    },
    
    selectFacility (facility: any) {
      // We are using this "globalObject" as a temporary holder of the facility
      // object so we can display the facility's name right away on the next page
      // to avoid the network delay making us show a blank name for a view milliseconds.
      globalObject.variable1 = facility;
      this.$router.push({name: 'Facility', params: {facilityId: facility.id}});
    },
    onCopy (param: any) {
      this.$notify({
        group: 'main',
        type: 'success',
        title: 'Successfully Copied',
        text: 'Text ' + param.text + ' has been copied.',
        // duration: 5000
      });  
    },
    onError (param: any) {
      console.log('Error!');
      console.log(param);
      this.$notify({
        group: 'main',
        type: 'error',
        title: 'Error Copying',
        text: 'Something went wrong copying to your clipboard.',
        // duration: 5000
      });  
    },
    goToSimpleSearch () {
      this.$router.push({name: 'Facilities'});
    },
    
  }
})



// WEBPACK FOOTER //
// ./src/components/facilities/FacilitiesAdvancedSearch.ts